<span id="shareholder-edit-section-{{ShareholderEditSection_.basicInfo}}"
      style="height:1px"></span>
<div class="shareholder-details">

  <form [formGroup]="shareholderForm"
        [hidden]="!shareholder?.id"
        (ngSubmit)="saveShareholder()"
        class="m-4"
        autocomplete="off"
        novalidate>

    <div class="row">

      <div class="col-sm-2">

        <div class="form-group"
             [class.error]="pin.invalid && (pin.dirty || pin.touched || mouseoverSaveShareholder)">
          <span class="fake-label">Last 4 SSN</span>
          @if (pin.invalid && (pin.dirty || pin.touched || mouseoverSaveShareholder)) {
            <em class="error-msg">
              Req
            </em>
          }
          <input formControlName="pin"
                 type="text"
                 mask="9990"
                 name="pin"
                 class="form-control" />
        </div>

      </div>

      <div class="col-sm-3">

        <div class="form-group">
          <span class="fake-label">Stock Lock Date <small>(opt.)</small></span>@if (canEdit) {
            <small class="pointable text-site-primary text-underline ps-2" (click)="repurchaseOptionAsOfDatePicker.setValue(null)">clear</small>
          }
            <div class="input-group">
              <input formControlName="repurchaseOptionAsOfDatePicker"
                     #repurchaseOptionAsOfDateInput="bsDatepicker"
                     type="text"
                     class="form-control"
                     container=""
                     placement="bottom"
                     bsDatepicker
                     [bsConfig]="datePickerBaseConfig">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                        type="button"
                        (click)="repurchaseOptionAsOfDateInput.toggle()">
                  <i class="fas fa-calendar-times"></i>
                </button>
              </div>
            </div>
          </div>

        </div>

      <div class="col-sm-3 col-button">

        @if (canEdit) {
          <span (mouseenter)="mouseoverSaveShareholder=true" (mouseleave)="mouseoverSaveShareholder=false">
            <app-button [buttonConfig]="{textChange: ['Update']}"
                        [isLoading]="isSubmitting"
                        [disabled]="!shareholderForm.valid || isSubmitting"
                        (textBtnClickEmt)="saveShareholder()"></app-button>
          </span>
        }

      </div>

      <div class="col-sm-4 col-button text-right">

        <button class="btn btn-md btn-primary" type="button"
                (click)="viewReport()">
          <i class="fa fa-search" style="font-size:12px;"></i> View Report</button>

      </div>

    </div>

  </form>

  <fieldset class="mt-4" [hidden]="shareholder?.id">
    <span id="shareholder-edit-section-{{ShareholderEditSection_.newEmployeeInfo}}">&nbsp;</span>

    <app-shareholder-new [shareholder]="shareholder"
                     (shareholderSectionUpdated)="shareholderSectionUpdated($event)"></app-shareholder-new>
  </fieldset>

  <fieldset [hidden]="!shareholder?.id" class="mb-4">
    <legend id="shareholder-edit-section-{{ShareholderEditSection_.planInfo}}">Stock Plan Info</legend>

    <app-shareholder-plan-list [shareholder]="shareholder"
                           [canEdit]="canEdit"
                           (shareholderSectionUpdated)="shareholderSectionUpdated($event)"></app-shareholder-plan-list>

  </fieldset>

  <fieldset [hidden]="!shareholder?.id">
    <legend id="shareholder-edit-section-{{ShareholderEditSection_.dividendInfo}}">Dividend Info</legend>

    <app-shareholder-dividend [shareholder]="shareholder"
                          [canEdit]="canEdit"
                          (shareholderSectionUpdated)="shareholderSectionUpdated($event)"></app-shareholder-dividend>

  </fieldset>

  <!--<div class="row">

    <div class="col text-right">

      <span (mouseenter)="mouseoverSaveShareholder=true" (mouseleave)="mouseoverSaveShareholder=false">
        <app-button [buttonConfig]="{textChange: ['Create']}"
                    [isLoading]="isSubmitting"
                    [disabled]="!itemBasicDataForm.valid || isSubmitting"
                    (textBtnClickEmt)="saveShareholder()"></app-button>
      </span>

    </div>

  </div>-->

</div>
